import { MODEL_NAMES } from '../constants/index';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

export const MAX_PARTICIPANTS = 9;

export default class MessagingConversationModel extends Model {
  @hasMany(MODEL_NAMES.USER, { async: false, inverse: null }) users;
  @hasMany(MODEL_NAMES.MESSAGE, { async: false, inverse: 'conversation' }) messages;
  @belongsTo(MODEL_NAMES.MESSAGE, { async: false, inverse: null }) lastMessage;

  @attr('boolean', { defaultValue: false }) disabled;
  @attr('boolean', { defaultValue: false }) inactive;
  @attr('boolean', { defaultValue: false }) isCouple;
  @attr('boolean', { defaultValue: false }) isDraft;
  @attr('boolean', { defaultValue: false }) isGroup;

  @attr('string') displayName;

  // Might be the id for a related couple record.
  @attr('string') linkExternalId;

  @attr('date') readAt;
  @attr('date') updatedAt;
  @attr('string', { defaultValue: '' }) messageDraft;

  @attr({
    defaultValue() {
      return {};
    },
  })
  counterpartReadAt;

  get messagesByCreatedAt() {
    return this.messages?.slice()?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  get mostRecentOwnMessage() {
    return this.messagesByCreatedAt?.find(message => !message.isSystem && message.isOwn);
  }

  get mostRecentReadAt() {
    const sortedReadAts = Object.values(this.counterpartReadAt).sort(
      (a, b) => new Date(b) - new Date(a)
    );
    return sortedReadAts.length ? new Date(sortedReadAts[0]) : new Date(this.readAt);
  }

  get lastReadOwnMessage() {
    return this.messagesByCreatedAt?.find(
      message => message.isOwn && new Date(message.createdAt) <= this.mostRecentReadAt
    );
  }

  get hasMessageDraft() {
    return this.messageDraft.trim().length > 0;
  }
}
